import React, { useMemo } from "react";
import { useTable, useSortBy, useFilters, usePagination } from "react-table";
import '../styles.css';

const CommonTable = ({ cols, data }) => {

    const columns = useMemo(() => cols, []);

    const tableInstance = useTable(
        { 
            columns, 
            data, 
            disableSortBy: false,
            initialState: { pageIndex: 0 } 
        },
        useFilters,
        useSortBy,
        usePagination
    );

    const options = {
    myPageOptions: [10, 20, 30, 40, 50]
    };

    let { myPageOptions } = options;

    const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, 
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    canFilter,
    state: { pageIndex, pageSize }
    } = tableInstance;

    return (
    <div>
    <div className="table-container">
        <table {...getTableProps()}>
        <thead>
            {headerGroups.map((headerGroup, index) => (
            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, colIndex) => (
                <th 
                    key={colIndex} 
                    {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                        {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                    </span>
                    <div style={{padding: "0px", margin: "5px 0px 0px 0px"}}>
                        {column.canFilter ? column.render('Filter') : null}
                    </div>
                </th>
                ))}
            </tr>
            ))}
        </thead>
        <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
            prepareRow(row);
            return (
                <tr key={`${row.id}-${index}`} {...row.getRowProps()}>
                {row.cells.map((cell, cellIndex) => {
                    return (
                    <td key={cellIndex} 
                        {...cell.getCellProps()}>
                        {cell.render("Cell")}
                    </td>
                    );
                })}
                </tr>
            );
            })}
        </tbody>
        </table>
        </div>
        <div style={{marginTop: "10px"}}>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {"<"}
        </button>{" "}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
            {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {">>"}
        </button>{" "}
        <span>
            Page{" "}
            <strong>
            {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
        </span>
        <span>
            | Go to page:{" "}
            <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
            }}
            style={{ width: "100px" }}
            />
        </span>{" "}
        <select
            value={pageSize}
            onChange={(e) => {
            setPageSize(Number(e.target.value));
            }}
        >
            {myPageOptions.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
                Show {pageSize}
            </option>
            ))}
        </select>
        </div>
        </div>
    );
};

export default CommonTable;
